import React from 'react';
import classnames from 'classnames';

import { PlainButton, SearchBar } from 'components';
import Icon from 'assets/icons';

import { useSearchState, useSearchDispatch } from 'context';

import styles from './SearchBar.module.scss';

export const SearchDown = () => {
  const { open } = useSearchState();

  const searchDispatch = useSearchDispatch();

  const toggleDrawer = React.useCallback(() => {
    searchDispatch({ type: 'TOGGLE_DRAWER' });
  }, [searchDispatch]);

  return (
    <>
      <PlainButton
        className={classnames(styles.searchDownTrigger, open && styles.open)}
        onClick={toggleDrawer}
      >
        <Icon.Search className={styles.searchDownIcon} />
      </PlainButton>

      {open && <SearchBar className={classnames(styles.searchBar, styles.searchDown)} size="Default" />}
    </>
  );
};
